import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { headingIds } from './headingIds';

/**
 * Stamps every heading of the editor's DOM with its stable id (headingIds.js)
 * after each update, so the outline rail and in-page links can target them.
 * DOM-only: ids are a view concern and never reach the saved body (the
 * sanitizer strips them anyway), so they cost nothing in sync or git.
 */
export default function HeadingIdsPlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    const stamp = () => {
      const root = editor.getRootElement();
      if (!root) return;
      const nodes = Array.from(root.querySelectorAll('h1, h2, h3'));
      const ids = headingIds(nodes.map((el) => el.textContent));
      nodes.forEach((el, i) => {
        if (el.id !== ids[i]) el.id = ids[i];
      });
    };
    stamp();
    return editor.registerUpdateListener(() => stamp());
  }, [editor]);
  return null;
}
